module.exports = __webpack_public_path__ + "static/white-24e5529cd5332a7fed5e7cd2f7c51b3b.png";